module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/change-status-modal/change-status-modal.component.css
// module id = ./src/app/projects/change-status-modal/change-status-modal.component.css
// module chunks = main